import { render, staticRenderFns } from "./AssignDeviceInformation.vue?vue&type=template&id=0c674cb0&scoped=true"
import script from "./AssignDeviceInformation.vue?vue&type=script&lang=js"
export * from "./AssignDeviceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c674cb0",
  null
  
)

export default component.exports